import React from "react";
import "../../../styles/contactos.css";
import site from "../../../imgs/Icons/site.svg";
import tel from "../../../imgs/Icons/tel.svg";
import fax from "../../../imgs/Icons/fax.svg";
import email from "../../../imgs/Icons/email.svg";
import morada from "../../../imgs/Icons/morada.svg";
import time from "../../../imgs/Icons/time_black.svg";
import { withNamespaces } from 'react-i18next';

const SegurancaPublica = ({t}) => {
  const formatPhoneValues = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `+351 ${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }

  return (
    <>
      <div
        className="accordion accordions_margin"
        id="accordionExample_segurancaPublica"
      >
        {/* 1 - PSP */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="psp">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cPsp"
              aria-expanded="true"
              aria-controls="cPsp"
            >
              {t('moduleContactosEmergencia:S4.A.A1.T')}
            </button>
          </h2>
          <div
            id="cPsp"
            className="accordion-collapse collapse"
            aria-labelledby="psp"
            data-bs-parent="#accordionExample_segurancaPublica"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S4.A.A1.ST1.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S4.A.A1.ST1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEmergencia:S4.A.A1.ST1.P2')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S4.A.A1.ST1.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEmergencia:S4.A.A1.ST1.P3')}>
                    {t('moduleContactosEmergencia:S4.A.A1.ST1.P3')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEmergencia:S4.A.A1.ST1.P4')}
                  >
                    {t('moduleContactosEmergencia:S4.A.A1.ST1.P4')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEmergencia:S4.A.A1.ST1.P5')}
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEmergencia:S4.A.A1.ST1.P6')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 2 - GNR */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="gnr">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cGnr"
              aria-expanded="true"
              aria-controls="cGnr"
            >
              {t('moduleContactosEmergencia:S4.A.A2.T')}
            </button>
          </h2>
          <div
            id="cGnr"
            className="accordion-collapse collapse"
            aria-labelledby="gnr"
            data-bs-parent="#accordionExample_segurancaPublica"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S4.A.A2.ST1.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S4.A.A2.ST1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEmergencia:S4.A.A2.ST1.P2')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S4.A.A2.ST1.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEmergencia:S4.A.A2.ST1.P3')}>
                    {t('moduleContactosEmergencia:S4.A.A2.ST1.P3')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEmergencia:S4.A.A2.ST1.P4')}
                    >
                      {t('moduleContactosEmergencia:S4.A.A2.ST1.P4')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEmergencia:S4.A.A2.ST1.P5')}
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEmergencia:S4.A.A2.ST1.P6')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 3 - POLICIA MUNICIPAL */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="pMunicipal">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cPMunicipal"
              aria-expanded="true"
              aria-controls="cPMunicipal"
            >
              {t('moduleContactosEmergencia:S4.A.A3.T')}
            </button>
          </h2>
          <div
            id="cPMunicipal"
            className="accordion-collapse collapse"
            aria-labelledby="pMunicipal"
            data-bs-parent="#accordionExample_segurancaPublica"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEmergencia:S4.A.A3.ST1.P1')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S4.A.A3.ST1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEmergencia:S4.A.A3.ST1.P2')}>
                    {formatPhoneValues(t('moduleContactosEmergencia:S4.A.A3.ST1.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a
                    className="link"
                    href={"mailto:" + t('moduleContactosEmergencia:S4.A.A3.ST1.P3')}>
                    {t('moduleContactosEmergencia:S4.A.A3.ST1.P3')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEmergencia:S4.A.A3.ST1.P4')}
                  >
                    {t('moduleContactosEmergencia:S4.A.A3.ST1.P4')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEmergencia:S4.A.A3.ST1.P5')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (SegurancaPublica);
